import { getGooglePlacesApiKey } from "./config";

/** Build a Places photo media URL (browser key; referrer-restricted). */
export const placePhotoMediaUrl = (
  photoName?: string | null,
  maxPx = 96,
): string | null => {
  const name = String(photoName ?? "").trim();
  const key = getGooglePlacesApiKey();
  if (!name || !key) return null;
  const url = new URL(`https://places.googleapis.com/v1/${name}/media`);
  url.searchParams.set("maxHeightPx", String(maxPx));
  url.searchParams.set("maxWidthPx", String(maxPx));
  url.searchParams.set("key", key);
  return url.toString();
};
